<template>
  <div class="energy-label-alert-notice" v-if="alerts && alerts.length">
    <span
      v-for="alert in alerts"
      :key="alert.type"
      class="badge badge-warning energy-label-alert-notice__badge"
    >{{ alert.message }}</span>
  </div>
</template>

<script>
  // Renders one badge per active energy-label alert (missing/expired/low). Reuses this admin
  // theme's existing `badge badge-warning` class (see Modules/Property/Resources/views/
  // partials/facilities.blade.php) rather than a bespoke style. Deliberately renders NOTHING
  // when `alerts` is empty - there is no success/green state in this component at all, so an
  // unknown/missing/ambiguous/failed-provider outcome can never be mistaken for "all good".
  export default {
    name: 'EnergyLabelAlertNotice',
    props: {
      alerts: {
        type: Array,
        default: () => [],
      },
    },
  };
</script>

<style>
  .energy-label-alert-notice {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 6px;
  }
  .energy-label-alert-notice__badge {
    display: inline-block;
  }
</style>
